import { render } from "./ConfirmationErrorSvg.vue?vue&type=template&id=5692003c"
import script from "./ConfirmationErrorSvg.vue?vue&type=script&lang=js"
export * from "./ConfirmationErrorSvg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4139241753/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__